import React, { createContext, useContext, useState, useCallback } from 'react';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutos

const DietsRoutinesCacheContext = createContext(null);

export function useDietsRoutinesCache() {
  const ctx = useContext(DietsRoutinesCacheContext);
  if (!ctx) {
    return {
      setDietsCache: () => {},
      setRoutinesCache: () => {},
      getDietsCache: () => null,
      getRoutinesCache: () => null,
      cacheTtlMs: CACHE_TTL_MS,
    };
  }
  return ctx;
}

export function DietsRoutinesCacheProvider({ children }) {
  const [dietsCache, setDietsCacheState] = useState(null);
  const [routinesCache, setRoutinesCacheState] = useState(null);

  const setDietsCache = useCallback((userId, diets) => {
    setDietsCacheState(
      diets == null ? null : { userId, diets: Array.isArray(diets) ? diets : [], at: Date.now() }
    );
  }, []);

  const setRoutinesCache = useCallback((userId, routines) => {
    setRoutinesCacheState(
      routines == null ? null : { userId, routines: Array.isArray(routines) ? routines : [], at: Date.now() }
    );
  }, []);

  const getDietsCache = useCallback((userId) => {
    if (!dietsCache || dietsCache.userId !== userId) return null;
    if (Date.now() - dietsCache.at > CACHE_TTL_MS) return null;
    return dietsCache.diets;
  }, [dietsCache]);

  const getRoutinesCache = useCallback((userId) => {
    if (!routinesCache || routinesCache.userId !== userId) return null;
    if (Date.now() - routinesCache.at > CACHE_TTL_MS) return null;
    return routinesCache.routines;
  }, [routinesCache]);

  const value = {
    setDietsCache,
    setRoutinesCache,
    getDietsCache,
    getRoutinesCache,
    cacheTtlMs: CACHE_TTL_MS,
  };

  return (
    <DietsRoutinesCacheContext.Provider value={value}>
      {children}
    </DietsRoutinesCacheContext.Provider>
  );
}
